(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('CheckSaveController', CheckSaveController);

    CheckSaveController.$inject = ['$state', '$uibModalInstance', 'AlertService'];

    function CheckSaveController($state, $uibModalInstance, AlertService) {
        var vm = this;
        vm.check = [];

        vm.totalObjects = [];
        vm.objects = [];
        var objects = localStorage.getItem("check-multiple-save");
        if(objects != null && objects != "null" && objects != undefined){
            vm.totalObjects = JSON.parse(objects);
            vm.page = 1;
            vm.systemQueryCount = Object.keys(vm.totalObjects).length;
            vm.systemItemLimit = 10;
            vm.systemNowTotalItems = Object.keys(vm.totalObjects).length;

            vm.objects = vm.totalObjects.slice(0, vm.systemItemLimit);
        }

        vm.changePage = function () {
            vm.objects = vm.totalObjects.slice((vm.page -1) * vm.systemItemLimit,
                ((vm.page -1) * vm.systemItemLimit) + vm.systemItemLimit);
        }

        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
            localStorage.setItem("check-multiple-save", JSON.stringify(vm.check));
        };

        vm.save = function () {
            $uibModalInstance.close();
            localStorage.setItem("check-multiple-save", JSON.stringify(vm.check));
        };

    }
})();
